import { omit, trimStart } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import URI from 'urijs';
import getOuterUrl from '../../services/get-outer-url';
import { isSeoViewMode } from '../../services/wix-sdk-utils';
import Wix from '../../services/wix-sdk-polyfill';

const isModifiedEvent = event => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const getLocation = (to, sectionUrl) => {
  let location;
  if (typeof to === 'object') {
    location = new URI(getOuterUrl(to.pathname, sectionUrl));
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new URI(getOuterUrl(to, sectionUrl));
  }
  return location.toString();
};

const getState = to => {
  let location;
  if (typeof to === 'object') {
    location = new URI(to.pathname);
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new URI(to);
  }
  return trimStart(location.toString(), '/');
};

const ExternalLink = ({ appDefinitionId, sectionId, to, children, renderInSeo, renderHref, sectionUrl, ...props }) => {
  const linkProps = omit(props, 'dispatch', 'user');

  const handleClick = event => {
    if (event.defaultPrevented) {
      return;
    }
    if (!renderHref || (renderHref && !isModifiedEvent(event))) {
      event.preventDefault();
      event.stopPropagation();

      Wix.Utils.navigateToSection({
        appDefinitionId,
        sectionId,
        shouldRefreshIframe: false,
      }, getState(to));
    }
  };

  if (isSeoViewMode() && !renderInSeo) {
    return (
      <div {...linkProps}>
        {children}
      </div>
    );
  }
  linkProps.href = '#';
  if (renderHref) {
    linkProps.href = getLocation(to, sectionUrl);
    linkProps.target = '_top';
  }

  return (
    <a onClick={handleClick} {...linkProps}>
      {children}
    </a>
  );
};

ExternalLink.propTypes = {
  appDefinitionId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  to: PropTypes.string,
  children: PropTypes.node,
  renderInSeo: PropTypes.bool,
  renderHref: PropTypes.bool,
  sectionUrl: PropTypes.string,
};

ExternalLink.defaultProps = {
  renderInSeo: true,
  renderHref: true,
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./app/components/link/external-link.js